export default "__VITE_ASSET__v_40tEjt__"